import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'
import clsx from 'clsx'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepConnector from '@material-ui/core/StepConnector'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import CreateIcon from '@material-ui/icons/Create'
import PublishIcon from '@material-ui/icons/Publish'
import HowToRegIcon from '@material-ui/icons/HowToReg'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Fab from '@material-ui/core/Fab'
import { useTheme, useThemeProps } from '@findep/microfronts-core'

function CustomizedStepper(inProps) {
  const props = useThemeProps({ props: inProps, name: 'MFCustomizedStepper' })
  const {
    currentStep = 0,
    iconos = {
      1: <PublishIcon />,
      2: <HowToRegIcon />,
      3: <CreateIcon />,
      4: <AttachMoneyIcon />
    },
    texts = [{ texto: 'DOCUMENTOS' }, { texto: 'REFERENCIAS' }, { texto: 'FIRMA DIGITAL' }, { texto: 'CONFIRMACIÓN' }],
    movil = false
  } = props
  const matches = useMediaQuery('(min-width:600px)')

  const [activeStep] = React.useState(currentStep)
  const steps = getSteps(texts)
  const { palette } = useTheme()

  const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 22
    },
    active: {
      '& $line': {
        backgroundImage: `linear-gradient(0deg, ${palette.primary.main} 1%, ${palette.primary.main} 48%, ${palette.primary.main} 100%)`
      }
    },
    completed: {
      '& $line': {
        backgroundImage: `linear-gradient(0deg, ${palette.primary.main} 1%, ${palette.primary.main} 48%, ${palette.primary.main} 100%)`
      }
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: `#ccc`,
      borderRadius: 1
    }
  })(StepConnector)

  const useColorlibStepIconStyles = makeStyles({
    root: {
      backgroundColor: '#ccc',
      zIndex: 1,
      color: '#fff',
      width: 50,
      height: 50,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center'
    },
    rootButton: {
      backgroundColor: '#ccc',
      zIndex: 1,
      color: '#000'
      // width: 50,
      // height: 50,
      // display: 'flex',
      // borderRadius: '50%',
      // justifyContent: 'center',
      // alignItems: 'center',
    },
    active: {
      backgroundImage: `linear-gradient(0deg, ${palette.primary.main} 1%, ${palette.primary.main} 48%, ${palette.primary.main} 100%)`,
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
    },
    completed: {
      backgroundImage: `linear-gradient(0deg, ${palette.primary.main} 1%, ${palette.primary.main} 48%, ${palette.primary.main} 100%)`
    }
  })

  function ColorlibStepIcon(props_in) {
    const classes_1 = useColorlibStepIconStyles()
    const { active, completed, iconos } = props_in

    const icons = iconos

    return (
      <div
        className={clsx(classes_1.root, {
          [classes_1.active]: active,
          [classes_1.completed]: completed
        })}
      >
        {icons[String(props.icon)]}
      </div>
    )
    
  }

  ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
    texto: PropTypes.string
  }

  function ButtonDegrade(props) {
    const classes_2 = useColorlibStepIconStyles()
    const { active, completed, texto, iconos } = props
    const icons = iconos

    return (
      <Fab
        variant='extended'
        className={clsx(classes_2.rootButton, {
          [classes_2.active]: active,
          [classes_2.completed]: completed
        })}
      >
        {icons[String(props.icon)]}
        {texto}
      </Fab>
    )
  }

  ButtonDegrade.propTypes = {
    ComponentExt: PropTypes.elementType.isRequired,
    texto: PropTypes.string
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      background: '#fafaf8'
    },
    button: {
      marginRight: theme.spacing(1)
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    desktop: {}
  }))

  const theme = createTheme({
    overrides: {
      MuiStepper: {
        root: {
          background: '#fafaf8'
        }
      }
    }
  })

  const classes = useStyles()
  function getSteps(texts) {
    return texts
  }

  return (
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
          {steps.map((row, index) => (
            <Step key={index + 3}>
              <StepLabel
                key={index + 1}
                id='steppermovil'
                style={{ display: matches === true ? 'none' : true }}
                StepIconComponent={(props) => ColorlibStepIcon({ ...props, iconos })}
              />
              <StepLabel
                key={index + 2}
                id='stepperdesktop'
                style={{ display: (matches === true) & !movil ? true : 'none' }}
                StepIconComponent={(props) => ButtonDegrade({ ...props, iconos, texto: row.texto })}
              />
              <StepLabel
                key={index + 3}
                id='steppermovil'
                style={{ display: (matches === true) & movil ? true : 'none' }}
                StepIconComponent={(props) => ColorlibStepIcon({ ...props, iconos })}
              />
            </Step>
          ))}
        </Stepper>
      </ThemeProvider>
    </div>
  )
}

CustomizedStepper.propTypes = {
  currentStep: PropTypes.number,
  iconos: PropTypes.object,
  texts: PropTypes.array,
  movil: PropTypes.bool
}

export default CustomizedStepper
